import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
import MainLayout from '../components/layout/MainLayout';
import AuthGuard from '../components/auth/AuthGuard';

const MainFeed = lazy(() => import('../components/feed/MainFeed'));
const UserProfile = lazy(() => import('../pages/UserProfile'));
const Settings = lazy(() => import('../pages/Settings'));
const PublicProfile = lazy(() => import('../pages/PublicProfile'));
const AdminLayout = lazy(() => import('../components/admin/AdminLayout'));
const UserManagement = lazy(() => import('../components/admin/UserManagement'));
const ContentModeration = lazy(() => import('../components/admin/ContentModeration'));
const PrivacyPolicy = lazy(() => import('../pages/policies/PrivacyPolicy/en'));
const TermsOfService = lazy(() => import('../pages/policies/TermsOfService/en'));
const ThirdPartyNotices = lazy(() => import('../pages/policies/ThirdPartyNotices/en'));
const AccountDeletion = lazy(() => import('../components/AccountDeletion/AccountDeletion'));
const AccountStatusWrapper = lazy(() => import('../components/auth/AccountStatusWrapper'));

export function AppRouter() {
  return (
    <RouterProvider 
      router={createBrowserRouter([
        {
          path: '/login',
          element: <AuthGuard />,
        },
        {
          path: '/account-status',
          element: <Suspense fallback={<div>Loading...</div>}><AccountStatusWrapper /></Suspense>
        },
        {
          path: '/admin/*',
          element: <Suspense fallback={<div>Loading...</div>}><AdminLayout /></Suspense>,
          children: [
            {
              index: true,
              element: <Navigate to="users" replace />
            },
            {
              path: 'users',
              element: <Suspense fallback={<div>Loading...</div>}><UserManagement /></Suspense>
            },
            {
              path: 'moderation',
              element: <Suspense fallback={<div>Loading...</div>}><ContentModeration /></Suspense>
            }
          ]
        },
        {
          path: '/*',
          element: <MainLayout />,
          children: [
            {
              index: true,
              element: <Suspense fallback={<div>Loading...</div>}><MainFeed /></Suspense>
            },
            {
              path: 'profile',
              element: <Suspense fallback={<div>Loading...</div>}><UserProfile /></Suspense>
            },
            {
              path: 'settings',
              element: <Suspense fallback={<div>Loading...</div>}><Settings /></Suspense>
            },
            {
              path: 'users/:userId',
              element: <Suspense fallback={<div>Loading...</div>}><PublicProfile /></Suspense>
            },
            {
              path: 'privacy',
              element: <Suspense fallback={<div>Loading...</div>}><PrivacyPolicy /></Suspense>
            },
            {
              path: 'terms',
              element: <Suspense fallback={<div>Loading...</div>}><TermsOfService /></Suspense>
            },
            {
              path: 'third-party-notices',
              element: <Suspense fallback={<div>Loading...</div>}><ThirdPartyNotices /></Suspense>
            },
            {
              path: 'data-deletion',
              element: <Suspense fallback={<div>Loading...</div>}><AccountDeletion /></Suspense>
            }
          ]
        }
      ], {
        future: {
          v7_relativeSplatPath: true
        }
      })}
      future={{
        v7_startTransition: true
      }}
    />
  );
} 